export function GradientBoxText({ text }: { text: string }) {
  return (
    <span className="gradient-text">
      <span className="inner-content">{text}</span>
    </span>
  )
}
